import { AbstractControl } from '@angular/forms';

export const validateHex = (
  control: AbstractControl
): { [key: string]: any } | null => {
  if (/^#[0-9A-F]{6}$/i.test(control.value)) {
    return null;
  }
  return { color: 'Invalid hexadecimal value' };
};
